<template>
  <div class="resultsTable">
    <div class="table-responsive">
      <table class="table table-bordered table-striped">
        <thead>
          <tr id="resultsHeaderSection">
            <th>
              <a
                v-on:click="
                  sortType = 'masterID';
                  sortReverse = !sortReverse;
                "
              >
                Cluster representative (ID)
                <i class="fas" :class="getSortType('masterID')"></i>
              </a>
            </th>
            <th>
              <a
                v-on:click="
                  sortType = 'score';
                  sortReverse = !sortReverse;
                "
              >
                e-value
                <i class="fas" :class="getSortType('score')"></i>
              </a>
            </th>
            <th>
              <a
                v-on:click="
                  sortType = 'ident';
                  sortReverse = !sortReverse;
                "
              >
                Identity
                <i class="fas" :class="getSortType('ident')"></i>
              </a>
              <!-- </th>
            <th>
              <a v-on:click="sortType = 'aliLen'; sortReverse = !sortReverse">
                Alignment length
                <i class="fas" :class="getSortType('aliLen')"></i>
              </a>
            </th> -->
            </th>

            <th>
              <a
                v-on:click="
                  sortType = 'queryCov';
                  sortReverse = !sortReverse;
                "
              >
                Query sequence coverage [%]
                <i class="fas" :class="getSortType('queryCov')"></i>
              </a>
            </th>
            <th>
              <a> Query start:end </a>
            </th>
            <th>
              <a
                v-on:click="
                  sortType = 'rmsd';
                  sortReverse = !sortReverse;
                "
              >
                Maximum RMSD in a cluster
                <i class="fas" :class="getSortType('rmsd')"></i>
              </a>
            </th>
            <th>
              <a
                v-on:click="
                  sortType = 'size';
                  sortReverse = !sortReverse;
                "
              >
                # of subclusters
                <i class="fas" :class="getSortType('size')"></i>
              </a>
            </th>
            <th>
              Subcluster representatives
              <span class="float-right">
                <button
                  type="button"
                  class="btn btn-sm"
                  :class="{
                    'btn-success': ligandFilterOn,
                    'btn-primary': !ligandFilterOn,
                  }"
                  uib-btn-checkbox
                  v-on:click="ligandFilterOn = !ligandFilterOn"
                >
                  <i class="icofont-atom"></i> Has ligands
                </button>
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(hit, index) in sortedResults" :key="index">
            <td>
              <span
                :style="{ color: hit.color, 'font-size': '20px' }"
                aria-label="Cluster color label"
                data-toggle="popover"
                data-placement="top"
                data-trigger="hover"
                data-content="Cluster color label"
              >
                <i class="fas fa-square"></i>
              </span>
              <a :href="clusterUrl(hit)" target="_blank">
                <b>{{ hit.masterID }}</b>
              </a>
            </td>
            <td>{{ hit.score }}</td>
            <td>{{ hit.ident }}</td>
            <!-- <td>{{hit.aliLen}}</td> -->

            <td>
              <span v-if="hit.hasOwnProperty('queryCov')">
                {{ hit.queryCov.toFixed(2) }}%
              </span>
              <span v-else><OutdatedBtn></OutdatedBtn></span>
            </td>

            <td>
              <span
                v-if="
                  hit.hasOwnProperty('queryStart') &&
                  hit.hasOwnProperty('queryEnd')
                "
              >
                {{ hit.queryStart }} : {{ hit.queryEnd }}
              </span>
              <span v-else><OutdatedBtn></OutdatedBtn></span>
            </td>

            <td>
              <i v-if="!hit.rmsd" class="fa fa-spinner fa-spin"></i>
              <span
                v-if="hit.rmsd"
                :class="{ 'text-danger': hit.rmsd === '-' }"
                >{{ hit.rmsd }}</span
              >
            </td>
            <td>
              <i v-if="!hit.size" class="fa fa-spinner fa-spin"></i>
              <span
                v-if="hit.size"
                :class="{ 'text-danger': hit.size === '-' }"
                >{{ hit.size }}</span
              >
            </td>
            <td>
              <i v-if="!hit.representatives" class="fa fa-spinner fa-spin"></i>
              <ul
                class="horizontal-slide"
                v-if="hit.representatives && hit.representatives.length > 0"
              >
                <li
                  v-for="subcluster in hit.representatives"
                  :key="subcluster.name"
                >
                  <PDBCard
                    :pdbInfo="subcluster"
                    v-if="!ligandFilterOn"
                  ></PDBCard>
                  <PDBCard
                    :pdbInfo="subcluster"
                    v-else-if="
                      subcluster.ligands && subcluster.ligands.length > 0
                    "
                  ></PDBCard>
                </li>
              </ul>
              <span
                v-if="hit.representatives && hit.representatives.length === 0"
                >No representatives found</span
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { eventBus } from "../main";
export default {
  name: "ResultsTable",
  components: {
    PDBCard: () => import("../components/PDBCard"),
    OutdatedBtn: () => import("../components/OutdatedBtn"),
  },
  props: {
    hits: Array,
  },
  mounted: function () {
    let c = 0;
    this.hits &&
      this.hits.forEach((h) => {
        h.representatives.forEach((r) => {
          r.selected && c++;
        });
      });
    this.selectedCount = c;
    this.$nextTick(function () {
      this.reinitPopups();
    });
  },
  created() {
    // eslint-disable-next-line no-unused-vars
    eventBus.$on("cartCleared", (data) => {
      // console.log('cleared')
      this.selectedCount = 0;
    });
    // eslint-disable-next-line no-unused-vars
    eventBus.$on("removedFromCart", (hit) => {
      // console.log('cleared')
      this.decSelected();
    });
  },
  updated: function () {
    this.$nextTick(function () {
      this.reinitPopups();
    });
  },
  computed: {
    sortedResults: function () {
      if (!this.hits) return [];

      let k = this.sortType;
      let o = this.sortReverse ? -1 : 1;

      let compare = function (a, b) {
        let res;
        if (k != "masterID") res = parseFloat(a[k]) > parseFloat(b[k]) ? 1 : -1;
        else res = a[k] > b[k] ? 1 : -1;
        return res * o;
      };

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.hits.sort(compare);
    },
  },
  data: function () {
    return {
      sortType: "score",
      sortReverse: false,
      cartLimit: 12,
      selectedCount: 0,
      ligandFilterOn: false,
    };
  },
  methods: {
    clusterUrl: function (hit) {
      return (
        "http://pdbflex.org/cluster.html#!/" +
        hit.masterID +
        "/" +
        hit.clusterDbId +
        "/" +
        hit.masterID
      );
    },
    reinitPopups: function () {
      window.jQuery('[data-toggle="popover"]').popover({
        boundary: "window",
      });
      window.jQuery('[data-toggle="tooltip"]').tooltip({
        boundary: "window",
      });
    },
    incSelected: function () {
      this.selectedCount++;
    },
    decSelected: function () {
      this.selectedCount = this.selectedCount < 1 ? 0 : --this.selectedCount;
    },
    canSelect: function () {
      return this.selectedCount < this.cartLimit;
    },
    resetCount: function () {
      this.selectedCount = 0;
    },
    getSortType: function (name) {
      let r = "fa-sort";
      if (this.sortType === name) {
        r = this.sortReverse ? "fa-sort-up" : "fa-sort-down";
      }
      return r;
    },
  },
};
</script>

<style scoped>
ul.horizontal-slide {
  margin: 0;
  padding: 0;
  width: 100%;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
}

ul.horizontal-slide li {
  display: inline-block;
  float: none;
}
</style>
